import { FormType } from '../../../form-types';
import { ZaludNoseSinusesQuestionFieldAnswers } from './questions';

const noseSinuses: FormType<ZaludNoseSinusesQuestionFieldAnswers> = {
  name: 'Nose & Sinuses',
  questions: [
    {
      key: 'zalud_noseSinuses_eyeSymptoms',
      next: {
        condition: { 'zalud_noseSinuses_eyeSymptoms.none': true },
        key: 'zalud_noseSinuses_sinusitisEpisodes',
        els: 'zalud_noseSinuses_ineligible'
      }
    },
    {
      key: 'zalud_noseSinuses_sinusitisEpisodes',
      next: {
        condition: { 'zalud_noseSinuses_sinusitisEpisodes.no': true },
        key: 'zalud_noseSinuses_fever',
        els: 'zalud_noseSinuses_ineligible'
      }
    },
    'zalud_noseSinuses_fever',
    {
      key: 'zalud_noseSinuses_symptoms',
      next: {
        condition: { 'zalud_noseSinuses_symptoms.facial_pain': true },
        key: 'zalud_noseSinuses_facialPainSide',
        els: 'zalud_noseSinuses_symptomDuration'
      }
    },
    'zalud_noseSinuses_facialPainSide',
    'zalud_noseSinuses_symptomDuration',
    'zalud_noseSinuses_symptomChange',
    'zalud_noseSinuses_coldOrFluStart',
    'zalud_noseSinuses_additionalComments',
    {
      key: 'zalud_noseSinuses_consent',
      next: {
        condition: { 'zalud_noseSinuses_consent.proceed': true },
        key: 'zalud_noseSinuses_complete',
        els: 'zalud_noseSinuses_ineligible'
      }
    },
    'zalud_noseSinuses_complete',
    'zalud_noseSinuses_ineligible'
  ]
};

export default noseSinuses;
